// Legal agreement copy for Link Ride signup flows.

export const DriverAgreementContent = (
  <div className="space-y-3">
    <p>By using the Link Ride platform as a driver, you agree:</p>

    <div>
      <p className="font-semibold text-white">1. Independent Contractor Status</p>
      <p>You are not an employee of Link-Lite Data LLC. You operate independently and are responsible for your own taxes, insurance, and expenses.</p>
    </div>

    <div>
      <p className="font-semibold text-white">2. Driver Requirements</p>
      <p>You confirm you have:</p>
      <ul className="list-disc ml-5 mt-1 space-y-0.5">
        <li>A valid driver's license</li>
        <li>A registered and roadworthy vehicle</li>
        <li>Active auto insurance</li>
        <li>A rideshare or commercial-use endorsement when transporting passengers or performing paid services</li>
      </ul>
    </div>

    <div>
      <p className="font-semibold text-white">3. Insurance Responsibility</p>
      <p>You are solely responsible for maintaining proper insurance coverage. Link-Lite Data LLC does not provide insurance coverage for drivers or their vehicles.</p>
    </div>

    <div>
      <p className="font-semibold text-white">4. Liability</p>
      <p>You accept full responsibility for any incidents, damages, injuries, or claims arising from your services.</p>
    </div>

    <div>
      <p className="font-semibold text-white">5. Service Conduct</p>
      <p>You agree to:</p>
      <ul className="list-disc ml-5 mt-1 space-y-0.5">
        <li>Safely transport passengers or items</li>
        <li>Verify orders before pickup/delivery</li>
        <li>Comply with all traffic laws</li>
      </ul>
    </div>

    <div>
      <p className="font-semibold text-white">6. Payments</p>
      <p>Payments may be collected via app, card, or cash. You agree to accurately record payment status.</p>
    </div>

    <div>
      <p className="font-semibold text-white">7. Platform Role</p>
      <p>Link-Lite Data LLC provides a connection platform only and is not responsible for service outcomes, delays, or disputes.</p>
    </div>

    <p className="text-white/90 font-semibold pt-2">By continuing, you agree to these terms.</p>
  </div>
);

export const CustomerAgreementContent = (
  <div className="space-y-3">
    <p>By using Link Ride services, you agree:</p>

    <div>
      <p className="font-semibold text-white">1. Service Type</p>
      <p>Link Ride provides on-demand pickup, delivery, and transportation services through independent drivers.</p>
    </div>

    <div>
      <p className="font-semibold text-white">2. Independent Drivers</p>
      <p>Drivers are not employees of Link-Lite Data LLC. They operate independently.</p>
    </div>

    <div>
      <p className="font-semibold text-white">3. Pricing</p>
      <p>Service fees are based on distance, time, and service type. Prices are shown before confirmation.</p>
    </div>

    <div>
      <p className="font-semibold text-white">4. Payments</p>
      <p>Payments may be completed via Stripe, in-person card payment, or cash.</p>
    </div>

    <div>
      <p className="font-semibold text-white">5. Order Responsibility</p>
      <p>Customers are responsible for:</p>
      <ul className="list-disc ml-5 mt-1 space-y-0.5">
        <li>Correct order details</li>
        <li>Verifying items upon delivery</li>
      </ul>
    </div>

    <div>
      <p className="font-semibold text-white">6. Liability Limitation</p>
      <p>Link-Lite Data LLC is not responsible for:</p>
      <ul className="list-disc ml-5 mt-1 space-y-0.5">
        <li>Restaurant errors</li>
        <li>Lost or damaged items</li>
        <li>Driver conduct</li>
      </ul>
    </div>

    <div>
      <p className="font-semibold text-white">7. Cancellations</p>
      <p>Once a driver has accepted or picked up an order, fees may apply.</p>
    </div>

    <div>
      <p className="font-semibold text-white">8. Contact Consent</p>
      <p>By submitting a request, you agree to be contacted regarding your order.</p>
    </div>

    <p className="text-white/90 font-semibold pt-2">Use of Link Ride constitutes acceptance of these terms.</p>
  </div>
);
